export default __webpack_public_path__ + "static/media/exclamation-circle.4a68c02b.svg";